import React, { useState, useEffect } from 'react';
import { Table, Spin } from 'antd';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import Uri from '../../Uri';
import Helper from '../helpers/Helper';
import PaginationComponent from '../utils/PaginationComponent';
import Swal from 'sweetalert2';
import { useAxios } from '../../App';
import { useMsal } from '@azure/msal-react';

export default function TargetHuman() {
    const axios = useAxios();
    const { instance: msalInstance } = useMsal();
    

    const authToken = localStorage.getItem("token");

    let [dataSource, setDataSource] = useState([]);
    let [dataSourceOld, setDataSourceOld] = useState([]);
    let [targetHuman, setTargetHuman] = useState("");
    let [targetHumanUpdate, setTargetHumanUpdate] = useState("");
    let [isInvalid, setIsInvalid] = useState();
    let [isInvalidUpdate, setIsInvalidUpdate] = useState();
    let [search, setSearch] = useState("");
    let [idData, setIdData] = useState("");
    let [loading, setLoading] = useState(true);

    let [currentPage, setCurrentPage] = useState();
    let [pageSize, setPageSize] = useState();
    let [totalData, setTotalData] = useState();

    const [showUpdate, setShowUpdate] = useState();
    const [showDelete, setShowDelete] = useState();

    function handleCloseDelete(e) {

        setShowDelete(false);

    };
    function handleShowDelete(e) {

        setShowDelete(true);

    }

    function handleCloseUpdate(e) {

        setShowUpdate(false);

    };

    function handleShowUpdate(e) {

        setShowUpdate(true);

    }

    const columns = [
        {
            title: 'Target Human',
            dataIndex: 'name',
            key: 'name',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.name.localeCompare(b.name),
            // responsive: ['sm','md','lg','xs'],
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            responsive: ['sm', 'md', 'lg', 'xs'],
            render: (text, record, index) => {
                return (
                    <>
                        <div className="btn-group" role="group" aria-label="Basic example">
                            <button type="button" className="btn btn-primary btn-sm" onClick={(e) => {
                                handleShowUpdate(e);
                                setTargetHumanUpdate(record.name);
                                setIdData(record.id);
                            }} id="update"><i className="bi bi-pencil-fill"></i>
                            </button>

                            <button type="button" className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                    handleShowDelete(e);
                                    setIdData(record.id);
                                }} id="delete"><i className="bi bi-trash-fill"></i>
                            </button>
                        </div>
                    </>
                )
            }
        }
    ]

    function _onChangeTargetHuman(e) {

        if (e.target.value) {

            setTargetHuman(e.target.value);

        } else {

            setTargetHuman("");

        }

    }

    function _onChangeTargetHumanUpdate(e) {

        if (e.target.value) {

            setTargetHumanUpdate(e.target.value);

        } else {

            setTargetHumanUpdate("");

        }

    }

    async function _saveData(e) {



        if (!targetHuman) {

            setIsInvalid(true);

            setTimeout(() => setIsInvalid(false), 3000);

        } else {


            let data = {

                "name": targetHuman,
                "created_by": localStorage.getItem("usernameLogin"),
                "updated_by": localStorage.getItem("usernameLogin")

            }

            await axios.post(Uri.rootUri + `master/target/human/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                .then(async function (response) {

                    // console.log(response);
                    caches.delete("targethuman");// delete cache for update

                    let cacheName = {

                        "name": "targethuman",
                        "created_by": localStorage.getItem("usernameLogin"),
                        "updated_by": localStorage.getItem("usernameLogin")

                    }

                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                        .then(function (response) {

                            // console.log(response);


                        })
                        .catch(function (error) {


                            console.log(error);

                        });

                    _loadDataAll("targethuman");

                    setTargetHuman("");

                    Helper.alert("Success", "success", "Success save data", 3000);

                    _loadData(currentPage, pageSize);



                })
                .catch(function (error) {

                    // console.log(error);

                    let objError = error.toJSON();

                    if (objError.status == 400) {

                        Helper.alert("Failed", "error", "Target already exist", 3000);

                    }




                });


        }

    }
    async function _updateTargetHuman(e) {

        e.preventDefault();

        if (!targetHumanUpdate) {

            setIsInvalidUpdate(true);

            setTimeout(() => setIsInvalidUpdate(false), 3000);

        } else {

            let data = {

                "name": targetHumanUpdate,
                "updated_by": localStorage.getItem("usernameLogin")

            }
            await axios.put(Uri.rootUri + `master/target/human/${idData}/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                .then(async function (response) {

                    // console.log(response);

                    caches.delete("targethuman");// delete cache for update

                    let cacheName = {

                        "name": "targethuman",
                        "created_by": localStorage.getItem("usernameLogin"),
                        "updated_by": localStorage.getItem("usernameLogin")

                    }

                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                        .then(function (response) {

                            // console.log(response);


                        })
                        .catch(function (error) {


                            console.log(error);

                        });

                    _loadDataAll("targethuman");

                    setTargetHumanUpdate("");

                    Helper.alert("Success", "success", "Success update data", 3000);

                    setShowUpdate(false);

                    _loadData(currentPage, pageSize);

                })
                .catch(function (error) {

                    console.log(error);



                    setShowUpdate(false);

                });




        }

    }

    async function _approveDelete(id, confirmation) {

        let data = {
            "confirmation": confirmation,
            "deleted_by": localStorage.getItem("usernameLogin")
        }

        try {
            await axios.put(Uri.rootUri + `master/target/human/${id}/delete/`, data, { headers: { "Authorization": `Bearer ${authToken}` } })
                .then(async function (response) {
                    // console.log(response);
                    caches.delete("targethuman");// delete cache for update
                    let cacheName = {
                        "name": "targethuman",
                        "created_by": localStorage.getItem("usernameLogin"),
                        "updated_by": localStorage.getItem("usernameLogin")

                    }
                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                        .catch(function (error) {
                            console.log(error);
                        });
                    _loadDataAll("targethuman");
                    setShowDelete(false);
                    Helper.alert("Success", "success", "Success delete data", 3000);
                    _loadData(currentPage, pageSize);
                })
        } catch (error) {
            setShowDelete(false);
            console.log(error);
            return error.response;
        }
    }

    async function _deleteTargetHuman(e, id) {

        e.preventDefault();
        setShowDelete(false);
        Swal.fire({
            title: 'Loading...',
            html: 'Please wait just a moment',
            timerProgressBar: true,
            didOpen: () => Swal.showLoading()
        })
        if (id) {
            const response = await _approveDelete(id, false);
            console.log(response);

            if (response?.status == 400 && response?.data?.res?.message == "Target human is used in incident") {
                Helper.dialogConfirmation(`Target human is used in ${response?.data?.res?.countOfIncident} incident(s). You cannot revert this operation.`, async () => await _approveDelete(id, true))
            }
        } else {
            setShowDelete(false);
        }

    }

    async function _loadDataAll(cachenameparam) {

        let arrCache = await caches.keys();// get cache

        await axios.get(Uri.rootUri + `cache/`)
            .then(async function (response) {

                //get version data if there is an update
                let dataResponse = response.data;

                //get data cache where cache name
                let resultObjCache = dataResponse.filter(item => item.name === cachenameparam);

                if (!arrCache.includes("targethuman")) {// if empty cache name in browser

                    // console.log("cache in browser empty");

                    await axios.get(Uri.rootUri + `master/target/human/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                        .then(function (response) {

                            // console.log(response);

                            let dataResponse = response.data;

                            Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponse);


                        })
                        .catch(function (error) {

                            console.log(error);

                        });

                    if (resultObjCache.length == 0) {// if data cache in database empty

                        let cacheName = {

                            "name": cachenameparam,
                            "created_by": localStorage.getItem("usernameLogin"),
                            "updated_by": localStorage.getItem("usernameLogin")

                        }

                        await axios.post(Uri.rootUri + `cache/`, cacheName)
                            .then(function (response) {

                                //   console.log(response);


                            })
                            .catch(function (error) {


                                console.log(error);

                            });

                    } else {

                        //   console.log("set version");

                        // if data cache in database not empty
                        Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                    }

                } else {

                    let resultData = arrCache.filter(x => x == "targethuman");

                    //Operation Caching Validation

                    resultData.forEach(async cachename => {

                        let cacheStorage = await caches.open(cachename);

                        let targetHumanResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + '/targethuman');
                        //get version in cache for check update data
                        let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + '/version'); // get data cache where url

                        if (!cacheResponse || cacheResponse == undefined || !targetHumanResponse || targetHumanResponse == undefined) {// check data valid or no valid

                            await axios.get(Uri.rootUri + `master/target/human/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                .then(function (response) {

                                    // console.log(response);

                                    let dataResponse = response.data;

                                    Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponse);


                                })
                                .catch(function (error) {

                                    console.log(error);

                                });

                            if (resultObjCache.length == 0) {// if data cache in database empty

                                let cacheName = {

                                    "name": cachenameparam,
                                    "created_by": localStorage.getItem("usernameLogin"),
                                    "updated_by": localStorage.getItem("usernameLogin")

                                }

                                await axios.post(Uri.rootUri + `cache/`, cacheName)
                                    .then(function (response) {

                                        // console.log(response);


                                    })
                                    .catch(function (error) {


                                        console.log(error);

                                    });

                            } else {

                                // if data cache in database not empty
                                Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                            }

                        } else {

                            let dataResponseVersion = await cacheResponse.json();

                            let dataResponseTargetHuman = await targetHumanResponse.json();

                            if (!dataResponseVersion || dataResponseVersion.length == 0 || !dataResponseTargetHuman || dataResponseTargetHuman.length == 0) {/*check data into cache empty or not empty*/

                                await axios.get(Uri.rootUri + `master/target/human/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                    .then(function (response) {

                                        // console.log(response);

                                        let dataResponse = response.data;

                                        Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponse);


                                    })
                                    .catch(function (error) {

                                        console.log(error);

                                    });

                                if (resultObjCache.length == 0) {// if data cache in database empty

                                    let cacheName = {

                                        "name": cachenameparam,
                                        "created_by": localStorage.getItem("usernameLogin"),
                                        "updated_by": localStorage.getItem("usernameLogin")

                                    }

                                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                                        .then(function (response) {

                                            // console.log(response);

                                        })
                                        .catch(function (error) {


                                            console.log(error);

                                        });

                                } else {

                                    // if data cache in database not empty
                                    Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                }

                            } else {

                                // dataResponseVersion and dataResponseTargetHuman there must be !

                                if (resultObjCache.length == 0) {// if data cache in database empty

                                    await axios.get(Uri.rootUri + `master/target/human/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                        .then(function (response) {

                                            // console.log(response);

                                            let dataResponse = response.data;

                                            Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponse);


                                        })
                                        .catch(function (error) {

                                            console.log(error);

                                        });

                                    let cacheName = {

                                        "name": cachenameparam,
                                        "created_by": localStorage.getItem("usernameLogin"),
                                        "updated_by": localStorage.getItem("usernameLogin")

                                    }

                                    await axios.post(Uri.rootUri + `cache/`, cacheName)
                                        .then(function (response) {

                                            // console.log(response);

                                        })
                                        .catch(function (error) {


                                            console.log(error);

                                        });

                                } else {

                                    //check version  cache local browser you and database api , resultObjCache there must be !
                                    let resultVersion = resultObjCache[0].version !== dataResponseVersion[0].version ? true : false;

                                    if (resultVersion) {

                                        // console.log("Update cache new version ");

                                        await axios.get(Uri.rootUri + `master/target/human/`, { headers: { "Authorization": `Bearer ${authToken}` } })
                                            .then(function (response) {

                                                // console.log(response);

                                                let dataResponse = response.data;

                                                Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponse);


                                            })
                                            .catch(function (error) {

                                                console.log(error);

                                            });

                                        Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                    } else {

                                        Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman`, dataResponseTargetHuman);

                                        Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/version`, resultObjCache);//set cache

                                    }

                                }


                            }

                        }

                    });

                }


            })
            .catch(function (error) {

                console.log(error);

            });

        // let arrCache = await caches.keys();// get cache

        // if(!arrCache.includes("targethuman")){

        //     await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //     .then(function(response){

        //         let dataResponse = response.data;

        //         Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //     })
        //     .catch(function(error){

        //         console.log(error);

        //     });

        // }else{

        //     let resultDataIncident = arrCache.filter( x => x == "targethuman"); //get where cache name

        //     resultDataIncident.map(async cachename => {

        //     let cacheStorage = await caches.open(cachename);

        //     let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + `/targethuman`);

        //     if(!cacheResponse || cacheResponse == undefined){

        //         await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //         .then(function(response){

        //             let dataResponse = response.data;

        //             Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //         })
        //         .catch(function(error){

        //             console.log(error);

        //         });

        //     }else{

        //         let dataResponse = await cacheResponse.json();

        //         if(!dataResponse || dataResponse.length == 0){

        //             await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //             .then(function(response){

        //                 let dataResponse = response.data;

        //                 Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //             })
        //             .catch(function(error){

        //                 console.log(error);

        //             });
        //         }

        //     }

        //     });

        // }
    }

    async function _loadData(page, pageSize) {

        setCurrentPage(page);

        setPageSize(pageSize);

        await axios.get(Uri.rootUri + `master/target/human/?page=${page}&page_size=${pageSize}`, { headers: { "Authorization": `Bearer ${authToken}` } })
            .then(function (response) {

                let dataResponse = response.data;

                // console.log(arr);

                setTotalData(dataResponse.count);

                setDataSource(dataResponse.results);

                setDataSourceOld(dataResponse.results);


            })
            .catch(function (error) {

                console.log(error);

            });

        // let arrCache = await caches.keys();// get cache

        // if(!arrCache.includes("targethuman")){

        //     await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //     .then(function(response){

        //         let dataResponse = response.data;

        //         // console.log(arr);
        //         setDataSource(dataResponse);

        //         setDataSourceOld(dataResponse);

        //         Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //     })
        //     .catch(function(error){

        //         console.log(error);

        //     });

        // }else{

        //     let resultData = arrCache.filter( x => x == "targethuman"); //get where cache name

        //     resultData.forEach(async cachename => {

        //       let cacheStorage = await caches.open(cachename);

        //       let cacheResponse = await cacheStorage.match(Helper.getHostCurrentUrl() + `/targethuman`);

        //       // console.log(dataResponse);

        //       if(!cacheResponse || cacheResponse == undefined){// if data in cache empty

        //         await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //         .then(function(response){

        //             let dataResponse = response.data;

        //             // console.log(arr);
        //             setDataSource(dataResponse);

        //             setDataSourceOld(dataResponse);

        //             Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //         })
        //         .catch(function(error){

        //             console.log(error);

        //         });

        //       }else{ //if data in cache not empty


        //         let dataResponse = await cacheResponse.json();

        //         if(!dataResponse || dataResponse.length == 0){

        //             await axios.get(Uri.rootUri + `master/target/human/`, { headers: {"Authorization" : `Bearer ${authToken}`} })
        //             .then(function(response){

        //                 let dataResponse = response.data;

        //                 // console.log(arr);
        //                 setDataSource(dataResponse);

        //                 setDataSourceOld(dataResponse);

        //                 Helper.addDataIntoCache("targethuman", Helper.getHostCurrentUrl() + `/targethuman` , dataResponse);


        //             })
        //             .catch(function(error){

        //                 console.log(error);

        //             });

        //         }else{


        //             setDataSource(dataResponse);


        //         }


        //       }


        //     });


        // }
    }

    async function onChange(page, pageSize) {

        // console.log(page,pageSize,currentPage); //page = new previous  page and new next page

        setPageSize(pageSize);

        setCurrentPage(page);

        let currentPageOnChange = page ? `page=${page}&` : 'page=1&';

        let currentPageSizeOnChange = pageSize ? `page_size=${pageSize}&` : 'page_size=20&';

        await axios.get(Uri.rootUri + `master/target/human/?${currentPageOnChange}${currentPageSizeOnChange}`, { headers: { "Authorization": `Bearer ${authToken}` } })
            .then(function (response) {

                let dataResponse = response.data;

                setTotalData(dataResponse.count);

                setDataSource(dataResponse.results);

                setDataSourceOld(dataResponse.results);

            })
            .catch(function (error) {

                console.log(error);

            });

    }
    useEffect(() => {
      const effect = async () => {

        //ajax call pending set loading
        // axios.setLoadingInterceptors(setLoading);
        await Helper.authorizationLogin(axios, msalInstance);

        await _loadData(1, 100);
        await _loadDataAll("targethuman");
        
        setLoading(false);
      }
      effect();
    }, []);


    return (
        <Spin size='large' spinning={loading}>
            <div className="typeofincident">
                <div className="row">
                    <div className="col-lg-4">
                        <h4>Add New Target Human:</h4>
                        <div className="mb-3">
                            <label htmlFor="targethuman" className='m-1 d-flex align-items-start'>Target Human <i className="bi bi-asterisk text-danger" style={{ fontSize: 8 }}></i></label>
                            {isInvalid && !targetHuman ?

                                <div id="targethuman" className="text-danger mb-1" style={{ fontSize: 14 }}>
                                    Please insert Target Human.
                                </div>
                                :
                                <></>
                            }
                            <input type="text" className="form-control" name="targethuman" id="targethuman" onChange={_onChangeTargetHuman} value={targetHuman && targetHuman} />
                        </div>
                        <button type="submit" className="btn btn-primary" style={{ width: "100%" }} onClick={_saveData} ><i className="bi bi-plus-circle-fill"></i> Add to Master Data</button>
                    </div>
                    <div className="col-lg-8">
                        <h4>Target Human Data</h4>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            scroll={{ x: 'max-content' }}
                            pagination={false}
                        />
                        <div className="text-center mt-3">
                            <PaginationComponent
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                onChange={onChange}
                                showSizeChanger={false}
                                total={totalData ? totalData : 0}
                                defaultPageSize={20}
                            />
                        </div>
                    </div>
                    <>
                        <Modal show={showUpdate} onHide={handleCloseUpdate} id={`update`}>
                            <Modal.Header closeButton>
                                <Modal.Title>Edit Data</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='mb-3'>
                                    <label htmlFor='type ' className='m-1 d-flex align-items-start'>Target Human <i className="bi bi-asterisk text-danger" style={{ fontSize: 8 }}></i></label>
                                    {isInvalidUpdate && !targetHumanUpdate ?

                                        <div id="type" className="text-danger mb-1" style={{ fontSize: 14 }}>
                                            Please insert Target Human.
                                        </div>
                                        :
                                        <></>
                                    }
                                    <input type="text" className="form-control" onChange={_onChangeTargetHumanUpdate} value={targetHumanUpdate ? targetHumanUpdate : ""} />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseUpdate}>
                                    Close
                                </Button>
                                <Button type="submit" variant="primary" onClick={_updateTargetHuman}>
                                    Save
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={showDelete} onHide={handleCloseDelete} id={`delete`}>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p className='m-0'>Delete this Target Human ?</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDelete}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={(e) => _deleteTargetHuman(e, idData)}>
                                    Ok
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>

                </div>
            </div>
        </Spin>
    );
}
